import React from 'react';
import { Link } from 'react-router-dom';



const CustomBtn = ({ step, classIcon, icon, secIc, title, className, classBtn, titleColor, handleClick }) => {

    return (
        <div onClick={handleClick} className={`${className} d-flex align-items-center left-btn mx-2 my-2`}>
            <span className='step'>{step}</span>
            <Link className={`${className} ${classBtn} py-1 text-start px-1 rounded-pill mx-1`}>
                <div className='d-flex align-items-center'>
                    <img className={classIcon} width={38} height={38} src={icon} />
                    <span className={`${titleColor} ps-3 pe-2 text-nowrap`}>{title}</span>
                    <img src={secIc} />
                </div>
            </Link>
        </div>
    );
};

export default CustomBtn;
